{
  "report": {
    "loadFailed": "Could not load report at this time",
    "cannotParse": "This report's definition could not be parsed."
  },
  "daily": {
    "title": "Daily Report",
    "download": "Download Daily Report",
    "editComments": "Edit Comments",
    "commentsTitle": "Daily Report Comments"
  },
  "morning": {
    "title": "Morning Meeting Report",
    "download": "Download Morning Meeting Report"
  },
  "comments": {
    "noRows": "There are no rows to comment on for this date.",
    "loadFailed": "Could not load the report comments.",
    "saveFailed": "Could not save the comments.",
    "saved": "Comments saved."
  },
  "library": {
    "title": "Report Library",
    "combine": "Combine",
    "combineSelected": "Combine ({{selected}})",
    "newReport": "New Eclipse Report",
    "createdBy": "Created by",
    "updated": "Updated",
    "empty": "No reports yet.",
    "emptyCanCreate": "No reports yet; create one with the Eclipse Report Builder.",
    "builtIn": "Built-in",
    "shared": "Shared",
    "wholeMine": "Whole mine",
    "viewReport": "View report",
    "renameReport": "Rename this report",
    "editSections": "Edit the sections in the builder",
    "cloneReport": "Clone into a new report",
    "deleteReport": "Delete report",
    "renameTitle": "Rename Report",
    "copyName": "{{name}} (copy)",
    "loadFailed": "Failed to load reports.",
    "leftOut": "\"{{name}}\" could not be parsed and was left out.",
    "pickTwo": "Pick at least two reports that can be combined.",
    "renameFailed": "Failed to rename the report.",
    "renamed": "Report renamed.",
    "deleteFailed": "Failed to delete the report.",
    "deleted": "Report deleted.",
    "confirmDelete": "Delete <strong>{{name}}</strong>? This removes it for everyone and cannot be undone."
  },
  "view": {
    "fallbackTitle": "Report",
    "loadFailed": "Failed to load the report.",
    "noShifts": "No shifts exist for this date.",
    "rangeFrom": "From",
    "rangeTo": "To",
    "run": "Run",
    "downloadPdf": "Download PDF"
  },
  "dataConnections": {
    "title": "Data Connections",
    "intro": "Connect Eclipse reporting data directly to Power BI, Excel, or any tool that supports REST APIs. Use the Eclipse Report Builder for in-app reports, or use these endpoints when you need to work in your own environment.",
    "authTitle": "Authentication",
    "authIntro": "All endpoints require authentication. Two methods are supported:",
    "apiKeyChip": "X-Api-Key header",
    "apiKeyBody": "Recommended for Power BI and Excel. Generate a long-lived key on the <keysPage>API Keys page</keysPage> and pass it as the <code>X-Api-Key</code> request header. Keys begin with <code>emw_</code>.",
    "bearerChip": "Bearer token",
    "bearerBody": "For programmatic access using the application login flow. Tokens expire after 1 hour; use the API key method for scheduled refreshes.",
    "powerBiTitle": "Connect with Power BI",
    "powerBiStep1": "In Power BI Desktop, go to <strong>Home → Get data → Blank query</strong>.",
    "powerBiStep2": "Open the Advanced Editor and paste the M query below. Replace <code>emw_YOUR_KEY_HERE</code> with your API key.",
    "powerBiStep3": "Change the endpoint URL to whichever endpoint you want from the list below. For date-filterable endpoints, bind <code>DateFrom</code> and <code>DateTo</code> to Power BI date parameters so report consumers can drive the range from the canvas.",
    "copyQuery": "Copy query",
    "powerBiQuery": "Power BI query",
    "excelTitle": "Connect with Excel (Power Query)",
    "excelStep1": "In Excel, go to <strong>Data → Get Data → From Other Sources → Blank Query</strong>.",
    "excelStep2": "Open the Advanced Editor, paste the query below, and replace the API key.",
    "excelStep3": "To change the date range, update the <code>DateFrom</code> and <code>DateTo</code> values at the top; or bind them to named cells so users can enter dates on a sheet.",
    "excelStep4": "If Excel prompts about privacy levels, set the data source to <strong>Organisational</strong>.",
    "excelQuery": "Excel query",
    "endpointsTitle": "Available endpoints",
    "endpointsIntro": "The reporting endpoints below return flat, denormalized data designed for direct use in BI tools. Each row includes all dimension labels; no joins are required.",
    "copyUrl": "Copy URL",
    "copied": "{{label}} copied",
    "fields": "Fields: {{fields}}"
  }
}
